<div style="float: left; position: relative">
  <ng-template
    #viewContainerRef
    (window:resize)="this.updateSubLayers(true)"
  ></ng-template>
</div>
<div *ngIf="this.horizontalLabels.length > 0" style="float: left; position: relative">
  <canvas id="horizontal_labels"></canvas>
</div>
